<template>
  <div class="keyword-search-result-tab">
    <h2 class="a11y-hidden">검색 결과 메뉴 네비게이션</h2>
    <div class="flex-menu-wrapper">
        <div class="tab" v-for="(tab) in tabList" :key="tab.value" @click="()=>changeKeywordTab(tab)"
             :data-index="tab.index">
          <div :class="currentTab === tab.type ? 'select' : ''">
            {{tab.text}}
          </div>
        </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex'
import { EventBus } from '@/components/eventbus/EventBus'

export default {
  name: 'keywordSearchResultTab',
  data () {
    return {
      tabList: [
        { text: '전체', type: 'all', index: 0 },
        { text: '프로그램', type: 'program', index: 1 },
        { text: '에피소드', type: 'vod', index: 2 },
        { text: 'LIVE', type: 'live', index: 3 },
        { text: '영화', type: 'movie', index: 4 },
        // { text: 'TV컷', type: 'clip', index: 5 },
        { text: '에디터Pick', type: 'theme', index: 6 },
        { text: '고객지원', type: 'faq', index: 7 }
      ],
      currentTab: 'all'
    }
  },
  computed: {
    ...mapGetters(['currentSearchResultTab'])
  },
  methods: {
    ...mapMutations(['setCurrentSearchResultTab']),
    changeKeywordTab (tab) {
      this.currentTab = tab.type
      this.moveMenuItem(tab.index)
      this.setCurrentSearchResultTab(tab.type)
    },
    moveMenuItem (index) {
      const clientWidth = document.body.clientWidth
      const mainMenuElements = document.querySelectorAll('div.tab')
      let targetEl = null
      for (let i = 0, len = mainMenuElements.length; i < len; i++) {
        if (+mainMenuElements[i].dataset.index === index) {
          targetEl = mainMenuElements[i]
        }
      }
      const rect = targetEl.getBoundingClientRect()
      let scrollLeft = (clientWidth / 2) - (rect.width / 2)
      // let targetPosition = rect.x - scrollLeft
      let targetPosition = (targetEl.offsetParent.offsetLeft + targetEl.offsetLeft) - scrollLeft
      targetEl.parentElement.parentElement.scrollBy({
        behavior: 'smooth',
        top: 0,
        left: targetPosition
      })
    },
    _onChangeTabEvent (type) {
      const targetTab = this.tabList.filter((tab) => {
        return tab.type === type
      })
      if (targetTab.length > 0) {
        this.changeKeywordTab(targetTab[0])
      }
    }
  },
  mounted () {
    EventBus.$on('tab-type', this._onChangeTabEvent)

    if (this.currentSearchResultTab !== '') {
      this._onChangeTabEvent(this.currentSearchResultTab)
    }
  },
  beforeDestroy () {
    EventBus.$off('tab-type', this._onChangeTabEvent)
  }
  // ,
  // watch: {
  //   currentSearchResultTab: (newVal) => {
  //     EventBus.$emit('tab-type', newVal)
  //   }
  // }
}
</script>

<style scoped>
  .keyword-search-result-tab {
    position: relative;
    width: 100%;
    height: 40px;
    top: 34px;
    overflow-x: scroll;
    padding: 0 25px;
  }
  .keyword-search-result-tab::-webkit-scrollbar{
    display: none;
  }
  .tab {
    background-color: transparent;
    color: #fff;
    font-size: 16px;
    float:left;
    text-align: center;
    display: inline;
    margin-right: 15px;
  }
  .tab div {
    height: 40px;
    padding: 0 12px;
    line-height: 40px;
    color: #a5a5a5;
  }
  .tab .select {
    border-bottom: 4px solid #1351f9;
    color: #fff;
  }
  .flex-menu-wrapper {
    width: max-content;
    height: 40px;
    padding: 0 5px 0 5px;
    position: relative;
  }

  .flex-menu-wrapper ul{
    white-space:nowrap;
  }

</style>
